/* eslint-disable @typescript-eslint/no-explicit-any */
import {BaseService} from "./BaseService.ts";

export class RoleService {

    static read = (others: any) => {
        return BaseService.apiClient(others).get("/role/read");
    };
}
